export const messages = {
    numberOfPetsRequired: 'Number of pets is required',
    numberOfPetsInvalid: 'Enter a number from 1 to 5',
    totalCupsPerDayRequired: 'Total cups per day is required',
    totalCupsPerDayInvalid: 'Enter a number from 0.5 to 20. Example: 2.5',
};
